import {
  FaLinkedinIn,
  FaTwitter,
  FaInstagram,
  FaTelegramPlane,
  FaTiktok,
  FaFacebook,
  FaYoutube,
  FaDiscord
} from "react-icons/fa";

import openseaIcon from "../images/icon/opensea.svg";
import mediumIcon from "../images/icon/med.svg";

const socialLinks = [
  // {
  //   thumb: openseaIcon,
  //   url: "http://opensea.io/collection/alphaoctopus",
  //   name: "OpenSea"
  // },
  {
    icon: <FaTwitter />,
    url: "https://twitter.com/alphaoctopusnft",
    name: "Twitter"
  },
  {
    icon: <FaYoutube />,
    url: "https://www.youtube.com/channel/UCdu88_OO8PrPDv2weYxSQpghttps://www.youtube.com/channel/UCdu88_OO8PrPDv2weYxSQpg",
    name: "YouTube"
  },
  {
    icon: <FaFacebook />,
    url: "https://www.facebook.com/AlphaOctopus/",
    name: "Facebook"
  },
  {
    icon: <FaInstagram />,
    url: "https://www.instagram.com/alphaoctopusnft/",
    name: "Instagram"
  },
  {
    icon: <FaTiktok />,
    url: "",
    name: "Telegram"
  },
  {
    icon: <FaDiscord />,
    url: "https://discord.gg/XEeghFerwh",
    name: "Discord"
  },
  // {
  //   thumb: <FaTiktok />,
  //   url: "https://www.tiktok.com/foryou?lang=en",
  //   name: "TikTok"
  // },
];

export default socialLinks;
